import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ValueProps from './components/ValueProps';
import HowItWorks from './components/HowItWorks';
import BlogCards from './components/BlogCards';
import FAQSection from './components/FAQSection';
import TestimonialSection from './components/TestimonialSection';
import CTASplitSection from './components/CTASplitSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuy.skin';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Itaobuy Sheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
  sameAs: ['https://kaspreadsheet.com'],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'support@kaspreadsheet.com',
    contactType: 'customer service',
  },
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  url: siteUrl,
  name: 'Itaobuy Sheet - Product Sourcing from China',
  description: 'The smartest way to buy from China. Itaobuy spreadsheet system simplifies product sourcing with faster ordering, lower fees, and full transparency.',
  inLanguage: 'en',
};

const faqItems = [
  { q: 'What is itaobuy spreadsheet?', a: 'It is a structured product sourcing system used to simplify buying from China. The itaobuy spreadsheet organizes the entire sourcing workflow into a single digital document — from browsing 14 product categories to order tracking and international shipping.' },
  { q: 'Is itaobuy spreadsheet safe?', a: 'Yes, it includes secure payment processing, verified supplier networks, quality inspection at consolidation warehouses, and shipping insurance. The spreadsheet format provides a complete audit trail of every transaction.' },
  { q: 'How does itaobuy spreadsheet work?', a: 'Users browse product categories, select items by copying product links, submit their compiled order, and an agent handles purchasing, quality verification, warehouse consolidation, and international shipping.' },
  { q: 'How much does itaobuy spreadsheet cost?', a: 'The system operates on a transparent, low-fee structure — typically much lower than traditional agent commissions of 5-15%. You pay the actual product price plus a clearly stated processing fee, with no hidden markups.' },
  { q: 'How long does shipping take?', a: 'Express international shipping typically delivers within 5-10 business days to most countries. Economy options take 15-30 days. Total order-to-delivery time averages 2-4 weeks including supplier processing and consolidation.' },
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a,
    },
  })),
};

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={faqSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ValueProps />
        <HowItWorks />
        <BlogCards />
        <TestimonialSection />
        <FAQSection />
        <CTASplitSection />
      </main>
      <Footer />
    </>
  );
}